import { Grid, styled, SxProps, TextField, Theme } from "@mui/material";

import { BasicInputIconPlacement, BasicInputMode } from "./enums";
import { IBasicInput } from "./types";

export const StyledInput = styled(TextField, {
  shouldForwardProp: (prop) =>
    prop !== "mode" &&
    prop !== "additionalIconPlacement" &&
    prop !== "iconType",
})<Pick<IBasicInput, "mode" | "additionalIconPlacement" | "iconType">>(
  ({ theme, mode, variant, iconType, additionalIconPlacement }) => ({
    backgroundColor: theme.palette.custom.default_gray,
    borderRadius: theme.typography.pxToRem(39),
    height: theme.typography.pxToRem(40),
    "label.Mui-disabled, .MuiFilledInput-root.Mui-disabled": {
      color: "inherit",
      backgroundColor: "inherit",
      "& input": {
        WebkitTextFillColor: "inherit",
      },
    },
    "> label": {
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.fontWeight._500,
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.text.primary,

      "&.Mui-focused": {
        color: theme.palette.custom.disable_text_gray,
      },
    },
    "> div": {
      height: "100%",
      "& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline":
        {
          border: "none",
        },
      "> input": {
        "&::placeholder": {
          color: theme.palette.text.primary,
          opacity: 1,
        },
      },
    },
    ...(variant === "filled" && {
      height: "100%",
      label: {
        left: "2px",
        ...((additionalIconPlacement === BasicInputIconPlacement.START ||
          iconType) && {
          left: "34px",
        }),
      },
      "& .MuiFilledInput-root": {
        borderRadius: theme.typography.pxToRem(39),
        overflow: "hidden",
        backgroundColor: theme.palette.custom.white,
        height: "40px",
        "&.Mui-focused": {
          backgroundColor: theme.palette.custom.white,
        },
        "&:hover": {
          backgroundColor: theme.palette.custom.white,
        },
        "&::before": {
          content: "none",
        },
        "&::after": {
          content: "none",
        },

        input: {
          backgroundColor: theme.palette.custom.white,
          paddingLeft: theme.spacing(4),
          ...((additionalIconPlacement === BasicInputIconPlacement.START ||
            iconType) && {
            paddingLeft: theme.spacing(9),
          }),
        },
      },
    }),
    ...(mode === BasicInputMode.LIGHT && {
      backgroundColor: theme.palette.custom.white,
      boxShadow: theme.customShadows.dropdown,

      input: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.fontWeight._600,
        "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
          WebkitAppearance: "none",
          margin: 0,
        },
        "&::placeholder": {
          fontWeight: theme.fontWeight._500,
        },
      },
    }),
    ...(mode === BasicInputMode.TYPOGRAPHY && {
      backgroundColor: theme.palette.custom.white,

      input: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.fontWeight._600,
        "&::placeholder": {
          fontWeight: theme.fontWeight._500,
        },
      },
    }),
  })
);

export const StyledInputIconWrapper = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "isEndPlacement",
})<{ isEndPlacement?: boolean }>(({ theme, isEndPlacement }) => ({
  display: "flex",
  position: "absolute",
  zIndex: theme.zIndex.minimal,
  top: "50%",
  transform: "translateY(-50%)",
  left: "14px",
  ...(isEndPlacement && {
    left: "calc(100% - 45px)",
  }),
}));

export const InputWrapperStyles: SxProps = {
  position: "relative",
  width: "100%",
};

export const InputsErrorStyles = (theme: Theme): SxProps<Theme> => ({
  position: "absolute",
  display: "flex",
  gap: theme.spacing(2),
  alignItems: "center",
  left: "16px",
  bottom: "-20px",
});

export const StyledBasicInputGridPosition = styled(Grid)({
  position: "relative",
});
